import {
  Box,
  Breadcrumb,
  BreadcrumbGroup,
  Button,
  Column,
  Heading,
  Icon,
  Row,
  StackedCell,
  StackedCellHeader,
  StackedCellValue,
  StackedSection,
  StackedTable,
  Text,
} from "@amzn/meridian";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "src/components/shared/loadingSpinner/loadingSpinner";
import ChatMessages from "./components/chatMessages/chatMessages";
import ConversationDetailSummary from "./components/conversationDetailSummary";
import AdminService from "./service/adminService";
import { ConversationDetails, ConversationSummary, Turn } from "./types";
import refreshTokens from "@amzn/meridian-tokens/base/icon/refresh";

const ConversationDetail = () => {
  const navigate = useNavigate();
  const { conversationId } = useParams();
  const [turns, setTurns] = useState<Turn[]>([]);
  const [summary, setSummary] = useState<ConversationSummary>();
  const [isLoading, setIsLoading] = useState(true);
  const cacheKey = `conversation-${conversationId}`;

  const loadConversationFromCache = () => {
    const data = sessionStorage.getItem(cacheKey);
    if (data) {
      const parsedData: ConversationDetails = JSON.parse(data);
      setTurns(parsedData.turns);
      setSummary(parsedData.summary);
      setIsLoading(false);
      return parsedData;
    }
    return null;
  };

  const loadConversationFromApi = async () => {
    setIsLoading(true);
    try {
      const data = await AdminService.getConversationDetails(conversationId);
      sessionStorage.setItem(cacheKey, JSON.stringify(data));
      setTurns(data.turns);
      setSummary(data.summary);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!loadConversationFromCache()) {
      loadConversationFromApi();
    }
  }, []);

  return (
    <div className="conversation-detail">
      <Row widths={["fill", "fit"]} spacingInset={"none none 300 none"}>
        <Heading level={2}>Conversation History</Heading>
        <Button type="tertiary" onClick={() => loadConversationFromApi()}>
          <Icon tokens={refreshTokens} />
        </Button>
      </Row>

      <BreadcrumbGroup>
        {/* always navigate to admin page when clicked on coversationList */}

        <Breadcrumb onClick={() => navigate("/admin/conversations")}>
          Conversation List
        </Breadcrumb>
        <Breadcrumb href={`/admin/conversations/${conversationId}`}>
          {conversationId}
        </Breadcrumb>
      </BreadcrumbGroup>

      {!isLoading ? (
        <div>
          <ConversationDetailSummary summary={summary} />
          <ChatMessages userAlias={summary.userAlias} turns={turns} />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default ConversationDetail;
